import type { ReactNode } from 'react';
import styles from './ToolGrantGroup.module.css';

export interface ToolGrantOption {
  key: string;
  label: string;
  description?: string;
  checked: boolean;
  /** A required built-in that is already granted; it renders checked and cannot be toggled. */
  locked: boolean;
  busy: boolean;
  badge?: string;
  onToggle: () => void;
}

interface ToolGrantGroupProps {
  legend: string;
  options: ToolGrantOption[];
  disabled: boolean;
  hint?: string;
  emptyNote?: ReactNode;
}

export const ToolGrantGroup = ({ legend, options, disabled, hint, emptyNote }: ToolGrantGroupProps) => {
  const hasOptions = options.length > 0;

  return (
    <fieldset className={styles.group}>
      <legend>{legend}</legend>
      {hasOptions
        ? options.map(option => (
            <label key={option.key} className={styles.tool} data-disabled={disabled || option.locked}>
              <input
                type="checkbox"
                checked={option.checked}
                disabled={disabled || option.locked}
                aria-busy={option.busy}
                onChange={option.onToggle}
              />
              <span className={styles.toolText}>
                <span className={styles.toolLabel}>{option.label}</span>
                {option.description && (
                  <span className={styles.toolDescription}>{option.description}</span>
                )}
              </span>
              {option.badge && <span className={styles.badge}>{option.badge}</span>}
            </label>
          ))
        : emptyNote}
      {hint && <p className={styles.hint}>{hint}</p>}
    </fieldset>
  );
};
